var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"rounded-lg tab-btn",class:{ 'tab-btn--active': _vm.active },style:({ marginRight: _vm.margin }),attrs:{"color":_vm.active ? 'secondary' : 'grey darken-2',"depressed":"","outlined":_vm.active && 3 === 2,"text":!_vm.active}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }